import React from 'react'
import { Checkbox, Col, Row } from 'antd'
import ExportExcelSheets from "../ExportExcelSheets";

class ExportExcelColumnsSelect extends React.Component {

  constructor(props) {
      super(props)
      this.state = {
          values: [],
          rawData: [],
          columns: [],
          allColumns: []
      }
  }

  componentDidMount() {
      const {columns, rawData, allColumns} = this.props
      const defaultValues = []
      columns?.forEach((column) => {
          defaultValues.push(column.dataIndex)
      })
      this.setState({
          values: defaultValues,
          columns: columns,
          allColumns: allColumns ?? columns,
          rawData: rawData,
      })
  }

    render() {

    const onChange = (checkedValues) => {
      this.setState({
          values: checkedValues
      })
    };

    const getCheckBoxItems = () => {
        const layout = []
         {this.state.allColumns?.forEach((column)=>{
              layout.push (
                <Col span={24}>
                  <Checkbox value={column.dataIndex}>{column.title}</Checkbox>
                </Col>
            )
        })}
        return layout
    }

    const getExcelColumns = () => {
        const excelColumns = []
        this.state.allColumns?.forEach((column) => {
            if (this.state.values?.includes(column.dataIndex)) {
                excelColumns.push({
                    label: column.title,
                    value: column.dataIndex,
                    style: column.excel?.style,
                    widthPx: column.excel?.widthPx
                })
            }
        })
        return excelColumns
    }

    return (
        <>
          <Row>
            <p>Select fields to export: </p>
          </Row>
            <Checkbox.Group onChange={onChange} value={this.state.values} style={{
                  width: '100%',
                }}>
              <Row>
                  {getCheckBoxItems()}
              </Row>
            </Checkbox.Group>
          <p/>
          <Row>
            <Col span={4}>
              <ExportExcelSheets columns={getExcelColumns()} dataset={this.state.rawData} fileName={this.props.fileName}/>
            </Col>
          </Row>
        </>
    )
  }
}

export default ExportExcelColumnsSelect
